import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceRefundsReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceRefunds,
  endpoint: "report/finance-refunds",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description: "Refunds",
    url: "https://help.commonsku.com/knowledge/new-client-invoicing-report",
  },
};

export default FinanceRefundsReportConfig;
